import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles({
    detailItem: {
        display: 'flex',
        marginBottom: 21,
        '& p:first-child': {
            fontSize: 16,
            color: '#013957',
            fontWeight: 'bold',
            width: 200,
        },
        '& p:last-child': {
            fontSize: 16,
            color: '#484848',
        },
        '& p span': {
            fontSize: 12,
        }
    },
    detailItemTax: {
        marginBottom: 10,
      '& div': {
          marginBottom: 0,
      }  
    },
    label: {
        fontSize:12,
        color: '#969696',
    },
    checkTax: {
        padding: 0,
        paddingLeft: 8,
    },
    totalItem: {
        '& p': {
            fontWeight: 'bold',
        }
    }
});

const ProposalDataDetails = ({
  active,
  detailsProposal,
  handleChangeCheckIVA
}) => {


  const classes = useStyles();

  return (
    <div>
      <div className={classes.detailItem}>
        <p>Subtotal</p>
        <p>
          {`$${detailsProposal.subtotal}.00`}
          <span>MXN</span>
        </p>
      </div>
      <div className={classes.detailItem}>
        <p>Descuento</p>
        <p>
          {`$${detailsProposal.discount}.00`}
          <span>MXN</span>
        </p>
      </div>

      <div className={classes.detailItemTax}>
        <div className={classes.detailItem}>
            <p>Impuesto del 16%</p>
            <p>
            {`$${detailsProposal.iva ? detailsProposal.iva : '0.00'}`}
            <span>MXN</span>
            </p>
        </div>

        <FormControlLabel
            control={
            <Checkbox
                checked={detailsProposal.checkIva}
                onChange={handleChangeCheckIVA}
                name="checkIva"
                color="secondary"
                className={{root: classes.checkTax}}
                disabled={!active ? true : false}
            />
            }
            label="Cotización con IVA incluido"
            classes={{label: classes.label}}
        />
      </div>

      <div className={`${classes.totalItem} ${classes.detailItem}`}>
        <p>Total</p>
        <p>
          {`$${detailsProposal.total ? detailsProposal.total : '0.00'}`}
          <span>MXN</span>
        </p>
      </div>
    </div>
  );
};

export default ProposalDataDetails;
